import { render } from "./ColChart.vue?vue&type=template&id=4f20c1e6"
import script from "./ColChart.vue?vue&type=script&lang=js"
export * from "./ColChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__